import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import React from 'react';

const OITableHeadingRow = ({
  styles,
  styles2,
  order,
  orderBy,
  state,
  setState,
}) => {
  const sortData = (type) => {
    setState({ orderBy: type });
    const { orderBy, order } = state;

    const isAsc = orderBy === type && order === 'asc';
    setState({ order: isAsc ? 'desc' : 'asc' });
  };
  return (
    <TableHead>
      <TableRow style={styles.tableRow}>
        <TableCell
          style={{
            ...styles2.modalTableHeaderCell,
            padding: 0,
            width: '90px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff', width: '65px' }}
            active={orderBy === 'date'}
            direction={orderBy === 'date' ? order : 'asc'}
            onClick={() => sortData('date')}
          >
            Date
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles2.modalTableHeaderCell,
            padding: 0,
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff' }}
            active={orderBy === 'contracts'}
            direction={orderBy === 'contracts' ? order : 'asc'}
            onClick={() => sortData('contracts')}
          >
            OI
          </TableSortLabel>
        </TableCell>

        <TableCell
          style={{
            ...styles2.modalTableHeaderCell,
            padding: 0,
            width: '42px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff', width: '42px' }}
            active={orderBy === 'oichg'}
            direction={orderBy === 'oichg' ? order : 'asc'}
            onClick={() => sortData('oichg')}
          >
            Chg
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles2.modalTableHeaderCell,
            padding: 0,
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff' }}
            active={orderBy === 'volume'}
            direction={orderBy === 'volume' ? order : 'asc'}
            onClick={() => sortData('volume')}
          >
            Volume
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            width: '32px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff', width: '42px' }}
            active={orderBy === 'bid'}
            direction={orderBy === 'bid' ? order : 'asc'}
            onClick={() => sortData('bid')}
          >
            Bid%
          </TableSortLabel>
        </TableCell>
        {/* )} */}
        {/* {!isMobile && ( */}
        <TableCell
          style={{
            ...styles.modalTableHeaderCell,
            width: '32px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff', width: '42px' }}
            active={orderBy === 'ask'}
            direction={orderBy === 'ask' ? order : 'asc'}
            onClick={() => sortData('ask')}
          >
            Ask%
          </TableSortLabel>
        </TableCell>
        {/* )} */}
        <TableCell
          style={{
            ...styles2.modalTableHeaderCell,
            padding: 0,
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff' }}
            active={orderBy === 'itemProb'}
            direction={orderBy === 'itemProb' ? order : 'asc'}
            onClick={() => sortData('itemProb')}
          >
            probITM
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles2.modalTableHeaderCell,
            padding: 0,
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff' }}
            active={orderBy === 'close'}
            direction={orderBy === 'close' ? order : 'asc'}
            onClick={() => sortData('close')}
          >
            Close
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles2.modalTableHeaderCell,
            padding: 0,
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff' }}
            active={orderBy === 'ivol'}
            direction={orderBy === 'ivol' ? order : 'asc'}
            onClick={() => sortData('ivol')}
          >
            IV
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles2.modalTableHeaderCell,
            padding: 0,
            width: '30px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff' }}
            active={orderBy === 'ivolchg'}
            direction={orderBy === 'ivolchg' ? order : 'asc'}
            onClick={() => sortData('ivolchg')}
          >
            Chg% {/* {isMobile ? 'Sprd' : 'Spreads'} */}
          </TableSortLabel>
        </TableCell>
        <TableCell
          style={{
            ...styles2.modalTableHeaderCell,
            padding: 0,
            width: '30px',
          }}
          className="sticky"
          align="right"
        >
          <TableSortLabel
            style={{ color: '#Fff' }}
            active={orderBy === 'RR'}
            direction={orderBy === 'RR' ? order : 'asc'}
            onClick={() => sortData('RR')}
          >
            RR$
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
export default OITableHeadingRow;



// WEBPACK FOOTER //
// ./src/components/Modals/OI Modal/components/OITableHeadingRow.jsx